import { Box } from "@mui/material";
import { Col, Row, useIsMobile } from "./Flexbox";
import { useState } from "react";
import Text from "./Text";
import CustomCheckbox from "./CustomCheckbox";
import { RolesNormalizer } from "../containers/RolesNormalizer";
import ConfirmationWindow from "./ConfirmationWindow";
import { FLAT_SCHEMA, getAllDescendantNames, getLeafDescendantNames, containsDescendant } from "../scripts/configs/PermissionsConfig";
const EditRoles = ({theme, onClose, activeRole, claims, updateRole, deleteRole, onSuccess, isDark}) => {
    const isMobile = useIsMobile();
    const [hideChildren, setHideChildren] = useState({});
    const [message, setMessage] = useState({text: null, color: null});
    const [showConfirm, setShowConfirm] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const {checkedRoles, handleChange, getPermissions, PERMISSIONS_SCHEMA} = RolesNormalizer(undefined, undefined, activeRole);
    //Other custom roles shouldn't appear as checkable permission groups
    const basePermissions = PERMISSIONS_SCHEMA.filter(item => !item.is_custom);
    const FULL_ACCESS_KEY = "acceso completo";
    const FULL_ACCESS_CHILD = "Otorgar todos los permisos"
    const isFullAccessSelected = checkedRoles[FULL_ACCESS_KEY] === true || checkedRoles[FULL_ACCESS_CHILD];

    const isGranularSelected = Object.keys(checkedRoles).some(key => 
        key !== FULL_ACCESS_KEY && key !== FULL_ACCESS_CHILD && checkedRoles[key] === true
    )

    const toggleSection = (section) => {
        setHideChildren(prev => ({
            ...prev, [section]: !prev[section]
        }));
    };

    const formatMessage = (text, color) => {
        setMessage({text: text, color: color || theme.Red})
    }

    const renderPermissionItem = (item) => {
        const childrenNames = item.children ? item.children.map(child => child.name) : [];
        const numChildren = childrenNames.length;
        const leafNames = getLeafDescendantNames(item);

        const markedChildrenCount = leafNames.length > 0 ? leafNames.filter(name => checkedRoles[name] === true).length : 0;

        const isIndeterminate = markedChildrenCount > 0 && markedChildrenCount < leafNames.length;
        const isParentChecked = leafNames.length > 0 ? markedChildrenCount === leafNames.length : checkedRoles[item.name] || false;

        const accessBranch = item.name === FULL_ACCESS_KEY || item.name === FULL_ACCESS_CHILD;
        const isAncestorOfFullAccess = containsDescendant(item, FULL_ACCESS_KEY);

        const isDisabled = accessBranch ? isGranularSelected : (isFullAccessSelected && !isAncestorOfFullAccess)

        const handleCheckClick = (e) => {
            if (isDisabled) return;
            const isChecked = e.target.checked;
            handleChange(item.name, isChecked, getAllDescendantNames(item));
        }
        //Check if it's a group
        const isGroup = numChildren > 0;
        const currentLabel = item.label || item.name;

        return (
            <Col key={item.name} style={{gap: 8, alignItems: 'starts', width: '100%', }}>
                <Row style={{justifyContent: 'flex-start', marginLeft: !isGroup ? 32 : 0}}>
                    <CustomCheckbox disabled={isDisabled} theme={theme} checked={isParentChecked} indeterminate={isIndeterminate} onChange={handleCheckClick} name={item.name}/>
                    <Text style={{cursor: isGroup ? 'pointer' : 'default', flexGrow: 1, display: 'flex'}} color={theme.Lao} weight='bold' onClick={() => {if (isGroup) toggleSection(item.name)}}>{currentLabel}</Text>
                </Row>
                {isGroup && !hideChildren[item.name] && (
                    <Box sx={{display: 'flex', flexDirection: 'column', marginLeft: 1, paddingBottom: 1}}>
                        {item.children.map(renderPermissionItem)}
                    </Box>
                )}
            </Col>
        )
    }

    const handleEdition = () => {
        setMessage(null);
        setShowConfirm(true);
    }

    const saveChanges = async () => {
        formatMessage(null);
        setShowConfirm(false);
        const permissionsToSave = getPermissions();
        // console.log("Rol a editar: ", activeRole.key);
        // console.log("Permisos: ", permissionsToSave)

        //Get the permissions in the schema to get their labels
        const labelMap = {};
        permissionsToSave.forEach(action => {
            const found = Object.values(FLAT_SCHEMA).find(item => 
                item.actions && Array.isArray(item.actions) && item.actions.includes(action)
            );
            if (found) {
                labelMap[action] = found.name;
                // console.log("LabelMap: ", labelMap)
            }
        })
        
        // console.log("Schema: ", FLAT_SCHEMA);
        const result = await updateRole(activeRole.key, permissionsToSave, labelMap);
        
        if (result.success) {
            formatMessage("El rol fue editado con éxito", theme.Verde)
            
            setTimeout(() => {
                onSuccess();
            }, 3000);
        } else {
            formatMessage(result.message, theme.Red);
        }
    }

    const handleErase = () => {
        setMessage(null);
        setShowDeleteConfirm(true);
    }

    const eraseRole = async() => {
        setShowDeleteConfirm(false);
        const result = await deleteRole(activeRole.key);

        if (result.success) {
            formatMessage("El rol fue eliminado con éxito", theme.Verde)
            
            setTimeout(() => {
                onSuccess();
            }, 3000);
        } else {
            formatMessage(result.message, theme.Red);
        }
    }

    return(
        <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', display: 'flex', justifyContent: 'center', zIndex: 1000, boxSizing: 'border-box', }}>
            <div style={{width:'100%', maxWidth: '600px', maxHeight: '635px', display: 'flex', alignItems:'flex-start', paddingLeft: isMobile ? 16 : 32, paddingRight: isMobile ? 16 : 32, paddingTop: 32, paddingBottom: 32, backgroundColor: theme.White,  borderRadius: 4, overflowY: 'auto', flexDirection: 'column', boxShadow: isDark ? '0px 10px 40px rgba(0, 0, 0, 0.8)' : '0px 10px 30px rgba(0, 0, 0, 0.1)'}}>
                <Col style={{flex:'none', width: '100%', alignItems:'flex-start', justifyContent: 'space-between', gap: 10, paddingBottom: 32}}>
                    <Text size={21} style={{color: theme.Black}} weight={"bold"}>Editar rol de permisos</Text>
                    <Text size={15} style={{fontStyle: "italic", color: theme.Black}}>{activeRole.nombre}</Text>
                    <Text color={theme.SEVENB} size={15}>Los cambios afectarán a {activeRole.usuarios} usuarios</Text>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', position: 'relative'}}>
                        {message?.text  && <Text color={message.color} size={12} style={{position: 'absolute' }}>{message.text}</Text>}
                    </div>
                </Col>
                <Col style={{gap: 8, alignItems: 'start', width: '100%'}}>
                    {basePermissions.map(renderPermissionItem)}
                </Col>
                <Row style={{width: '100%', alignItems: 'flex-start', height: 28, marginTop: 25}}>
                    {(claims.actions?.includes("deleteuser") || claims.groups?.includes("superadmin")) && (
                        <Text style={{cursor:'pointer', transition:'transform 2s ease', flex: 1, height: 20, textAlign: 'start'}} size={15} onClick={() => handleErase()} color={theme.Red}>Eliminar</Text>
                    )}
                    <Row style={{width: '100%', justifyContent: 'end', gap: 16}}>
                        <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.SEVENB} size={15} onClick={onClose}>Cancelar</Text>
                        <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Magenta} size={15} onClick={handleEdition}>Guardar cambios</Text>
                    </Row>
                </Row>
            </div>
            {showConfirm && (<ConfirmationWindow theme={theme} message={`Estás seguro de querer cambiar los permisos del rol ${activeRole.nombre}?`} btnText={"Confirmar"} action={saveChanges} onClose={() => setShowConfirm(false)}/>)}
            {showDeleteConfirm && (<ConfirmationWindow theme={theme} message={`Estás seguro de querer eliminar el rol ${activeRole.nombre} de forma permanente?`} btnText={"Eliminar rol"} action={eraseRole} onClose={() => setShowDeleteConfirm(false)}/>)}
        </div>
    )
}

export default EditRoles;